import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { UpdateUserMappingProps } from 'shared/service';

export function useUpdateUserMapping() {
  const { userMappingService } = useService();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<void, Error, UpdateUserMappingProps>(
    request => userMappingService.updateUserMapping(request),
    {
      mutationKey: MUTATION_KEYS.updateUserMapping,
      onSuccess: () => {
        enqueueSnackbar('mapping updated successfully', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('there was a problem updating mapping', { variant: 'error' });
      },
      onSettled: (_, __, { id }) => {
        queryClient.invalidateQueries([QUERY_KEYS.userMappings, id]);
        queryClient.invalidateQueries([QUERY_KEYS.commodityUserMappings, id]);
      },
    }
  );

  return mutation;
}
